var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box text-center",class:{ 'main-box-success': _vm.success, 'main-box-danger': _vm.danger }},[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }